var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActor5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_302)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.33 105.116C81.2311 105.116 104.66 81.5853 104.66 52.5582C104.66 23.5311 81.2311 0 52.33 0C23.4289 0 0 23.5311 0 52.5582C0 81.5853 23.4289 105.116 52.33 105.116Z",
    fill: "#0061A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_302",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 106
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.33 105.116C81.2311 105.116 104.66 81.5853 104.66 52.5582C104.66 23.5311 81.2311 0 52.33 0C23.4289 0 0 23.5311 0 52.5582C0 81.5853 23.4289 105.116 52.33 105.116Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_302)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 48.2192C27.51 48.6511 26.61 85.1998 33 92.6823H69.2C69.2 92.6823 79.09 64.6205 72.35 48.2192H27.59",
    fill: "#A86D22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.35 68.3066H42.31V81.8655H62.35V68.3066Z",
    fill: "#F9C2A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.17 78.1195C50.19 79.3247 53.5 80.0478 56.75 80.078C58.61 80.088 60.51 79.857 62.35 79.5356V68.3169H42.31V75.3273C43.72 76.5727 45.51 77.4666 47.17 78.1195Z",
    fill: "#EDEDED"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.02 42.786C74.09 42.2838 74.93 41.4703 75.3 41.1991C76.12 40.5865 76.95 41.2192 77.19 42.0127C77.4 42.7258 77.43 43.5293 77.48 44.2624C77.61 46.0602 77.33 47.8279 76.53 49.455C75.99 50.5397 75.15 51.4336 74.15 52.1065C74.15 52.1065 73.07 52.6489 72.86 51.4034L74.03 42.786H74.02Z",
    fill: "#F9C2A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.85 43.8705C73.9 43.5089 74.5 42.9364 74.77 42.7356C75.36 42.2937 75.95 42.7456 76.13 43.3181C76.28 43.8303 76.3 44.4028 76.34 44.9251C76.43 46.2107 76.24 47.4762 75.66 48.6412C75.27 49.4146 74.67 50.0574 73.95 50.5395C73.95 50.5395 73.18 50.9211 73.03 50.0373L73.87 43.8705H73.85Z",
    fill: "#E1B099"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.13 42.786C30.06 42.2838 29.22 41.4703 28.85 41.1991C28.03 40.5865 27.2 41.2192 26.96 42.0127C26.75 42.7258 26.73 43.5293 26.67 44.2624C26.55 46.0602 26.82 47.8279 27.62 49.455C28.16 50.5397 29 51.4336 30 52.1065C30 52.1065 31.08 52.6489 31.29 51.4034L30.12 42.786H30.13Z",
    fill: "#F9C2A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 43.8705C30.25 43.5089 29.65 42.9364 29.38 42.7356C28.79 42.2937 28.2 42.7456 28.03 43.3181C27.88 43.8303 27.86 44.4028 27.82 44.9251C27.73 46.2107 27.92 47.4762 28.5 48.6412C28.89 49.4146 29.49 50.0574 30.21 50.5395C30.21 50.5395 30.98 50.9211 31.13 50.0373L30.29 43.8705H30.3Z",
    fill: "#E1B099"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.68 44.4129C74.68 50.0976 73.7 55.8425 71.04 60.7538C68.71 65.0525 65.21 68.4975 61.45 71.2494C58.4 73.4791 55.13 76.0804 51.28 75.759C47.26 75.4275 44.13 71.9826 41.19 69.3009C37.06 65.5245 33.8 60.8342 31.79 55.3102C30.55 51.9054 29.98 48.0687 29.98 44.4028C29.98 26.0331 39.99 14.4829 52.33 14.4829C64.67 14.4829 74.68 26.0331 74.68 44.4028V44.4129Z",
    fill: "#F9C2A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.82 88.0023L61.06 81.4438H43.6L21.84 88.0023C21.84 88.0023 11.76 92.311 10.63 105.94H94.02C92.9 92.311 82.81 88.0023 82.81 88.0023H82.82Z",
    fill: "#F9C2A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.35 86.0537L70.79 84.3765L52.33 102.897L33.82 84.3865L29.47 85.6922C29.47 85.6922 31.1 92.3009 29.98 105.93H75.18C74.06 92.3009 76.35 86.0437 76.35 86.0437V86.0537Z",
    fill: "#00B1C3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 33.5355C31.3 33.5355 36.59 36.2373 50.35 36.9504L53.36 27.1378L54.08 36.9504C54.08 36.9504 58.24 37.2416 65.4 36.0866L66.69 30.6229L68.27 35.8054C68.27 35.8054 72.14 35.5141 73.27 33.1137C73.27 33.1137 71 15.0854 54.38 13.4985C54.38 13.4985 35.55 13.7697 31.32 33.5355H31.3Z",
    fill: "#F9B233"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17 16.2906C39.66 16.0395 42.29 12.705 42.44 12.5443C45.42 9.54125 49.95 8.50676 54.04 8.75785C65.04 9.42073 73.44 16.0897 77.29 26.4145C78.62 29.97 79.53 34.0276 79.86 37.814C79.86 37.814 82.01 62.5816 79.86 87.1081C79.86 87.1081 79 95.5447 79.72 104.674C79.72 104.674 70.69 106.824 71.12 89.4683L71.98 64.7208L73.25 42.9463C73.25 42.9463 73.84 32.7721 69.83 30.904C69.83 30.904 40.2 16.3006 40.17 16.2906Z",
    fill: "#F9B233"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.59 13.2874C46.59 13.2874 27.7 13.9402 28.85 41.1986L29.98 42.7553C29.98 42.7553 36.02 26.5851 45.76 22.9795L46.59 13.2773V13.2874Z",
    fill: "#F9B233"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.81 83.4921L29.47 85.7017C25.41 73.2175 27.62 49.4644 27.62 49.4644C27.62 49.4644 29.32 52.5678 30.87 52.2263C30.87 52.2263 32.15 56.8163 33.46 59.1765C33.45 65.8154 33.69 75.7887 36.81 83.4921Z",
    fill: "#F9B233"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.66,
    height: 105.94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActor5);
export default __webpack_public_path__ + "static/media/actor5.0b805822fa87a14fbb4bbc6dcbf735f2.svg";
export { ForwardRef as ReactComponent };